(function() {
  if (window.HanselProductPrefetch) return;

  var MAX_PREFETCHES = 4;
  var prefetched = {};
  var count = 0;
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  function canPrefetch() {
    if (count >= MAX_PREFETCHES) return false;
    if (connection && connection.saveData) return false;
    if (connection && /(^|-)2g$/.test(connection.effectiveType || '')) return false;
    return true;
  }

  function productUrlFromTarget(target) {
    var link = target && target.closest ? target.closest('a[href*="/products/"]') : null;
    if (!link) return '';

    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      if (url.origin !== window.location.origin) return '';
      if (url.pathname.indexOf('/products/') === -1) return '';
      if (url.href === window.location.href) return '';
      url.hash = '';
      return url.href;
    } catch (error) {
      return '';
    }
  }

  function prefetchProduct(target) {
    if (!canPrefetch()) return;

    var href = productUrlFromTarget(target);
    if (!href || prefetched[href]) return;

    var hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.as = 'document';
    hint.href = href;
    hint.setAttribute('data-hansel-product-prefetch', 'true');

    if ('fetchPriority' in hint) {
      hint.fetchPriority = 'low';
    }

    prefetched[href] = true;
    count += 1;
    document.head.appendChild(hint);
  }

  function handleIntent(event) {
    prefetchProduct(event.target);
  }

  document.addEventListener('pointerover', handleIntent, { passive: true });
  document.addEventListener('focusin', handleIntent);
  document.addEventListener('touchstart', handleIntent, { passive: true });

  window.HanselProductPrefetch = {
    prefetch: prefetchProduct
  };
}());
